// Logos shown under the Walley payment option (files in /assets/logos/banks/<name>.svg).
//
// A business (B2B) booking pays through Walley's business store: invoice or card only, so it
// shows just Walley, Mastercard and Visa. Consumers also get the banks and MobilePay.

const CONSUMER_LOGOS = [
  'aktia', 'alandsbanken', 'danske', 'mobilepay', 'nordea',
  'omasp', 'osuuspankki', 'pop', 'revolut', 'saastopankki', 'spankki',
  'walley', 'mastercard', 'visa',
];

const BUSINESS_LOGOS = ['walley', 'mastercard', 'visa'];

export const walleyPaymentLogos = (isBusinessBooking: boolean): string[] =>
  isBusinessBooking ? BUSINESS_LOGOS : CONSUMER_LOGOS;
